import { Settings, CropRotate, ViewInAr, CloudOutlined, FavoriteBorder, Public, PersonOutlined, AddLocationAltOutlined, PhoneIphone, EmailOutlined, Facebook, Twitter, Instagram, YouTube } from "@mui/icons-material"


export const navlink = [
  {
    url: "/",
    text: "Home",
  },
  {
    url: "/about",
    text: "About",
  },
  {
    url: "/services",
    text: "Services",
  },
  {
    url: "/portfolio",
    text: "Portfolio",
  },
  {
    url: "/testimonials",
    text: "Testimonials",
  },
  {
    url: "/blog",
    text: "Blog",
  },
  {
    url: "/contact",
    text: "Contact",
  },
]
export const home = [
  {
    text: "HELLO I'M",
    name: "VINAY KUMAR SAIN",
    post: "WEB DESIGNER",
    design: "UI / UX DESIGNER",
    desc: "HELLO my name is vinay kumar sain learn in ccsu university that is a practice project for react js",
  },
]
export const about = [
  {
    desc: "Hey, I’m Vinay, a web devlopment . I love exploring Web tecnology and creating portfolio website. With a background in BCA from ccsu, I strive to become a webb devloper. When I’m not working, you’ll find me playing chess.",
    desc1: "Tech enthusiast | Passionate about IT | Lifelong Learner | Let’s connect and create something amazing!",
    cover: "./photos/vinaay.jpg",
  },
]
export const services = [
  {
    id: 1,
    icon: <Settings />,
    title: "Creative Design",
    desc: "Lorem Ipsum simply text of the printing and type setting industry when an unknown printing simply",
  },
  {
    id: 2,
    icon: <CropRotate />,
    title: "Clean Code",
    desc: "Lorem Ipsum simply text of the printing and type setting industry when an unknown printing simply",
  },
  {
    id: 3,
    icon: <ViewInAr />,
    title: "Responsive Design",
    desc: "Lorem Ipsum simply text of the printing and type setting industry when an unknown printing simply",
  },
]
export const project = [
  {
    id: 1,
    icon: <CloudOutlined />,
    num: "3",
    title: "HAPPY CLIENTS",
  },
  {
    id: 2,
    icon: <FavoriteBorder />,
    num: "2",
    title: "PROJECTS COMPLEATED",
  },
  {
    id: 3,
    icon: <Public />,
    num: "108",
    title: "FILES DOWNLOADED",
  },
  {
    id: 4,
    icon: <PersonOutlined />,
    num: "4",
    title: "Friends",
  },
]
export const portfolio = [
  {
    id: 1,
    cover: "../photos/portfolio1.gif",
    name: "Brand",
    category: "marketing",
    title: "Brex Logo",
  },
  {
    id: 2,
    cover:"../photos/portfolio2.gif",
    name: "Brand",
    category: "design",
    title: "Brex Logo",
  },
  {
    id: 3,
    cover:"../photos/portfolio3.gif",
    name: "Brand",
    category: "development",
    title: "Brex Logo",
  },
  {
    id: 4,
    cover: "../photos/portfolio1.gif",
    name: "Brand",
    category: "marketing",
    title: "Brex Logo",
  },
  {
    id: 5,
    cover: "../photos/portfolio3.gif",
    name: "Brand",
    category: "design",
    title: "Brex Logo",
  },
  {
    id: 6,
    cover:"../photos/portfolio2.gif",
    name: "Brand",
    category: "development",
    title: "Brex Logo",
  },
]
export const testimonials = [
  {
    id: 1,
    text: "vinay is an incredibly dedicated and skilled professional. Their expertise in react js and commitment to excellence make them a valuable asset to any team.",
    image: "../photos/sarkari.png",
    name: "VINAY KUMAR SAIN",
    post: "Front End Developer",
  },
  {
    id: 2,
    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam porttitordapibus dictum.Fusce faucibus ligula scelerisque, eleifend turpis in",
    image: "../photos/portfolio5.jpg",
    name: "Alex Ander",
    post: "Back End Developer",
  },
  {
    id: 3,
    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam porttitordapibus dictum.Fusce faucibus ligula scelerisque, eleifend turpis in",
    image: "../photos/portfolio4.jpg",
    name: "GorkCoder",
    post: "React Developer",
  },
]
export const blog = [
  {
    id: 1,
    title: "Master These Awesome",
    date: "Jun 27, 2022",
    author: "Dorian Gray",
    desc: "Lorem Ipsum has been standard.",
    cover: "../photos/blog.gif",
  },
  {
    id: 2,
    title: "Best Design Items to Appeal",
    date: "Jun 27, 2022",
    author: "Dorian Gray",
    desc: "Lorem Ipsum has been standard. ",
    cover: "../photos/blog.gif",
  }, 
  {
    id: 3,
    title: "The 20 Best Lightroom Presets",
    date: "Jun 27, 2022",
    author: "Dorian Gray",
    desc: "Lorem Ipsum has been standard. ",
    cover: "../photos/blog.gif",
  },
]
export const contact = [
  {
    icon: <AddLocationAltOutlined />,
    text1: "216 ramnagar near shagun sweet",
    text2: "Ghaziabad,201001",
  },
  {
    icon: <PhoneIphone />,
    text1: "7982537040",
  },
  {
    icon: <EmailOutlined />,
    text1: "kumarsainvinay15@gmail.com",
   
  },
]
export const social = [
  {
    icon: <Facebook />,
  },
  {
    icon: <Twitter />,
  },
  {
    icon: <Instagram />,
  },
  {
    icon: <YouTube />,
  },
]
